import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PasswordPolicy } from '../../../pre-login/helpers/password.policy.validator';
import { UpdatePosUserValuesService } from '../../services/update-pos-user-values.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mandatory-pos-modal',
  templateUrl: './mandatory-pos-modal.component.html',
  styleUrls: ['./mandatory-pos-modal.component.css'],
})
export class MandatoryPosModalComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  firstNameError: string;
  lastNameError: string;
  submitted = false;
  posDetailsForm: FormGroup;
  currentFacility: FacilityObject;
  currentHostPath: string = '';

  @Output() onsignout: EventEmitter<string> = new EventEmitter();
  @Output() onClose: EventEmitter<string> = new EventEmitter();

  // subscriptions
  private _facilityOnChange: Subscription;

  constructor(
    private rootScopeService: RootScopeService,
    private fb: FormBuilder,
    private updatePOSUserDetailsService: UpdatePosUserValuesService,
    private _facilityService: FacilityService,
    private loader: HaloLoaderService
  ) {
    this.getRootScopeData();
  }

  ngOnInit() {
    this.currentHostPath =  environment.currentHostPath;
    this.posDetailsForm = this.fb.group({
      iAccept: [false, Validators.requiredTrue],
    });
    if (this.rootScopeData.currentUser.resetPassword) {
      this.posDetailsForm.addControl('password', this.fb.control('', Validators.required));
      this.posDetailsForm.validator = PasswordPolicy('password');
    }

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacility = res;
    });
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  get posDetailsValidator() {
    return this.posDetailsForm.controls;
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => (this.rootScopeData = rootScopeData));
  }

  logoutUser() {
    localStorage.setItem('islfcpartswebsiteLinked', 'true');
    localStorage.setItem('userID', this.rootScopeData.currentUser.userId + '');
    if (localStorage.getItem('newEquipmentAdded')) {
      localStorage.removeItem('newEquipmentAdded');
    }
    this.onsignout.emit();
  }

  submitPOSUserInfo(e: Event): void {
    this.submitted = true;
    if (this.posDetailsForm.invalid) {
      //alert("invalid");
      return;
    }

    const postData: any = {};
    postData.user = {};
    if (this.rootScopeData.currentUser.resetPassword) {
      postData.user.password = btoa(unescape(encodeURIComponent(this.posDetailsForm.value.password)));
      postData.user.resetPassword = false;
    }
    if (this.rootScopeData.managerData.isSubscriptionAccepted === false)
      postData.ownerOptedFacilities = [...this.rootScopeData.managerData.ownerOptedFacilities];
    postData.user.acceptTnC = this.posDetailsForm.value.iAccept;
    this.loader.startProcess();
    this.updatePOSUserDetailsService.updatePOSUserValues(postData).subscribe(
      data => {
        this.rootScopeData.currentUser.resetPassword = false;
        this.rootScopeData.currentUser.acceptTnC = true;
        this.rootScopeData.managerData.isSubscriptionAccepted = true;
        this.loader.endProcess();
        this.onClose.emit();
      },
      error => {
        this.loader.endProcess();
        console.error('API failed.');
      }
    );
  }

  stopPropagation(e: Event) {
    e.stopPropagation();
  }
}
